<canvas 
    #canvas 
    class="color-slider" 
    width="50" 
    height="250" 
    (mousedown)="onMouseDown($event)" 
    (mousemove)="onMouseMove($event)">
</canvas>